module.exports = __webpack_public_path__ + "assets/img/DATOSPERSONALES.9cfd18a9.svg";